import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { Table, Icon, Popconfirm } from 'antd'
import { TableContainer } from 'components'
import ScansColumns from 'views/ScanSettings/Scans/components/ScansColumns'
import { NoData } from 'components'
import useAxios from 'axios-hooks'
import { useProjects } from 'context/project-context'
import { getAuthHeader } from 'utils/auth'
import { notificationToast } from 'components/NotificationToast';
import {MANAGE_SCAN_PERMISSION} from 'utils/constants'; 
import { useUser } from 'context/user-context'

const StyledTable = styled(Table)`
	min-width: 1200px;
`;

const StyledScansData = styled.div({
	marginTop: 20
})

const Header = styled.a({
	margin: '10px',
	padding: '0 15px',
	display: 'inline-block',
	fontWeight: 500
})

const HeaderText = styled.span({
	marginLeft: 5,
	display: 'inline-block'
})

const Delete = ({ selectedRowKeys, setSelectedRowKeys, fetchScans }) => {
	const user = useUser();

	let scanOrScans = selectedRowKeys.length > 1 ? 'SCANS' : 'SCAN'

	const { project } = useProjects()
	let isAllowed = user.permissions.filter((p) => MANAGE_SCAN_PERMISSION.includes(p));

	const [{ data, loading, error }, deleteScans] = useAxios(
		{
			url: `${project.name}/scan-settings/scans`,
			method: 'DELETE',
			headers: getAuthHeader(),
			validateStatus: false
		},
		{ manual: true }
	)

	useEffect(() => {
		if (data && data.Errors && data.Errors.length) {
			openNotification(data.Errors)
		}
		if (data === '') {
			openNotification()
			fetchScans()
			setSelectedRowKeys([])
		}
	}, [data])

	const openNotification = errors => {
		if (!errors) {
			notificationToast({
				message: 'Success',
				description: 'Scans were deleted succesfully',
				icontype: "check"
			})
		} else {
			notificationToast({
				message: 'Error',
				description: `Could not delete scans. ${errors.join()}`,
				icontype: "alert"
			})
		}
	}

	const handleDelete = (e, selectedRowKeys) => {
		e.stopPropagation()
		deleteScans({ data: { ids: selectedRowKeys } })
	}

	
	return !!isAllowed.length && (
		<Header>
			<Icon type="delete" style={{ fontSize: 14 }} />
			<Popconfirm title="Are you sure you want to delete?" okText="Yes" cancelText="No" onConfirm={e => handleDelete(e, selectedRowKeys)}>
				<HeaderText>
					DELETE {selectedRowKeys.length} {scanOrScans}
				</HeaderText>
			</Popconfirm>
		</Header>
	)
}

const ScansData = ({ data, loading, setSelectedScans, scanSettingsId, navigate, fetchScans, pageCount }) => {
	const [selectedRowKeys, setSelectedRowKeys] = useState([])

	const onSelectChange = selectedRowKeys => {
		setSelectedRowKeys(selectedRowKeys)
		setSelectedScans(selectedRowKeys)
	}

	const rowSelection = {
		selectedRowKeys,
		onChange: onSelectChange
	}
	const { project } = useProjects()

	const handleStopScan = (e, item) => {
		let data = {id: item.id}
		stopScan({data})
	}
	

	const [{ data: startData, loading: startLoading, error: startError }, stopScan] = useAxios({
		url: `${project.name}/scan-settings/stop`,
		method: 'POST',
		headers: getAuthHeader()
	}, {manual: true})

	return (
		<StyledScansData>
			{selectedRowKeys.length > 0 && (
				<Delete fetchScans={fetchScans} selectedRowKeys={selectedRowKeys} setSelectedRowKeys={setSelectedRowKeys} />
			)}
			<TableContainer id="ScansTable">
				<StyledTable
					rowKey="id"
					pagination={{ hideOnSinglePage: true }}
					columns={ScansColumns(scanSettingsId, pageCount,handleStopScan)}
					dataSource={data}
					loading={loading}
					rowSelection={rowSelection}
					locale={{
						emptyText: <NoData />
					}}
				/>
			</TableContainer>
		</StyledScansData>
	)
}

export default ScansData
